import { render, staticRenderFns } from "./ResourceCalendarRegionsTab.vue?vue&type=template&id=35963224&scoped=true"
import script from "./ResourceCalendarRegionsTab.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarRegionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35963224",
  null
  
)

export default component.exports